/* global Word */

import type { TemplateProfile } from '../templates';
import { renumberExhibitTables } from '../word/exhibit/renumbering';
import { ElementRegistry } from './registry';
import { disclaimerElement } from './disclaimer';
import { footnoteElement } from './footnote';
import { executiveSummaryElement } from './executiveSummary';
import { boxSummaryElement } from './boxSummary';
// import { formatProductTitleElement } from './formatTitle';
import { sectionHeader1Element, sectionHeader2Element } from './sectionHeader';
import { tableElement, insertTableElement as insertTableElementForProfile } from './table';
import { textBlockFullElement, textBlockLeftElement, textBlockRightElement } from './textBlock';
import { fullExhibitElement, insertGraphFullLayout as insertGraphFullLayoutForProfile } from './fullExhibit';
import { halfExhibitElement, insertGraphHalfLayout as insertGraphHalfLayoutForProfile } from './halfExhibit';
import { doubleExhibitElement, insertGraphDoubleLayout as insertGraphDoubleLayoutForProfile } from './doubleExhibit';
import {
  halfWithTextExhibitElement,
  insertGraphHalfWithTextLayout as insertGraphHalfWithTextLayoutForProfile,
} from './halfWithTextExhibit';
import { firstPageExhibitElement, insertGraphFirstPageLayout as insertGraphFirstPageLayoutForProfile } from './firstPageExhibit';
import { doubleTableExhibitElement, insertDoubleTableLayout as insertDoubleTableLayoutForProfile } from './doubleTableExhibit';
import { tableGraphExhibitElement, insertTableGraphLayout as insertTableGraphLayoutForProfile } from './tableGraphExhibit';
import { calloutBoxElement } from './calloutBox';

const elements = [
  // formatProductTitleElement,
  textBlockLeftElement,
  textBlockRightElement,
  textBlockFullElement,
  calloutBoxElement,
  sectionHeader1Element,
  sectionHeader2Element,
  disclaimerElement,
  footnoteElement,
  executiveSummaryElement,
  boxSummaryElement,
  tableElement,
  fullExhibitElement,
  halfExhibitElement,
  doubleExhibitElement,
  doubleTableExhibitElement,
  tableGraphExhibitElement,
  halfWithTextExhibitElement,
  firstPageExhibitElement,
];

/** Shared application element registry. */
export const elementRegistry = new ElementRegistry(elements);

/** Toolbar action wrapper for full exhibit insertion. */
export async function insertGraphFullLayout(profile: TemplateProfile): Promise<void> {
  await insertGraphFullLayoutForProfile(profile);
}

/** Toolbar action wrapper for half exhibit insertion. */
export async function insertGraphHalfLayout(profile: TemplateProfile): Promise<void> {
  await insertGraphHalfLayoutForProfile(profile);
}

/** Toolbar action wrapper for double exhibit insertion. */
export async function insertGraphDoubleLayout(profile: TemplateProfile): Promise<void> {
  await insertGraphDoubleLayoutForProfile(profile);
}

/** Toolbar action wrapper for half-with-text exhibit insertion. */
export async function insertGraphHalfWithTextLayout(profile: TemplateProfile): Promise<void> {
  await insertGraphHalfWithTextLayoutForProfile(profile);
}

/** Toolbar action wrapper for first-page exhibit insertion. */
export async function insertGraphFirstPageLayout(profile: TemplateProfile): Promise<void> {
  await insertGraphFirstPageLayoutForProfile(profile);
}

/** Toolbar action wrapper for double table exhibit insertion. */
export async function insertDoubleTableLayout(profile: TemplateProfile): Promise<void> {
  await insertDoubleTableLayoutForProfile(profile);
}

/** Toolbar action wrapper for table graph exhibit insertion. */
export async function insertTableGraphLayout(profile: TemplateProfile): Promise<void> {
  await insertTableGraphLayoutForProfile(profile);
}

/** Toolbar action wrapper for table box insertion. */
export async function insertTableLayout(profile: TemplateProfile): Promise<void> {
  await insertTableElementForProfile(profile);
}

/** Re-sequences all exhibit numbers in the document (use after deleting an exhibit). */
export async function renumberExhibits(profile: TemplateProfile): Promise<void> {
  await Word.run(async (context) => {
    await renumberExhibitTables(context, profile);
  });
}

export type { ElementDefinition, ElementCategory } from './types';
export { ElementRegistry } from './registry';
export type { TemplateProfile } from '../templates';
